import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  stripeBackground: {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    zIndex: '1',
  },
  visible: {
    display: 'block',
  },
  hide: {
    display: 'none',
  },
}));

export const Backdrop = (props) => {
  const { isVisible, isStripe } = props;
  const classes = useStyles();

  return (
    <Box
      className={`${classes.backdrop} ${
        isVisible ? classes.visible : classes.hide
      } ${isStripe ? classes.stripeBackground : ''}`}
    ></Box>
  );
};
